import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=5f937e32&scoped=true&"
import script from "./activity-list.vue?vue&type=script&lang=js&"
export * from "./activity-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=5f937e32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f937e32",
  null
  
)

export default component.exports